module.exports = __webpack_public_path__ + "img/img-bg-unitel.a0d120b8.svg";